import { render, staticRenderFns } from "./NsSelect.vue?vue&type=template&id=6564f5a3&"
import script from "./NsSelect.vue?vue&type=script&lang=js&"
export * from "./NsSelect.vue?vue&type=script&lang=js&"
import style0 from "./NsSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6564f5a3')) {
      api.createRecord('6564f5a3', component.options)
    } else {
      api.reload('6564f5a3', component.options)
    }
    module.hot.accept("./NsSelect.vue?vue&type=template&id=6564f5a3&", function () {
      api.rerender('6564f5a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsSelect.vue"
export default component.exports